import React, { useEffect, useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import { sendTrackingActionEmail } from "./../../../../store/slices/isTrackingActionSlice";
import { useSnackbar } from "notistack";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";
import { reAssignProjectToOP } from "../../../../store/slices/managerProjectAssign";
import {
  projectReviewManagerAction,
  projectReviewOpAction,
} from "../../../../store/slices/SalesProjectAssignSlices/projectAssignedAction";
import { cancelPersonFromProjectAssign } from "../../../../store/slices/cancelPersonFromProjectSlice";
import { fetchWorkEntriesProjectTracking } from "../../../../store/slices/workentriesSlice";
import { fetchDescriptionTasksProjectTracking } from "../../../../store/slices/DescriptionTask";
import { fetchHardwareDescriptions } from "../../../../store/slices/hardwareDescriptionSlice";
import { triggerEmployeesCancelAssignedRefresh } from "../../../../store/slices/ProjectAssign/projectAssignCancelStateSlice";
import { fetchHardware } from "../../../../store/slices/hardwareSlice";
import { getAllAssemblyInventory } from "../../../../store/slices/assemblyInventorySlice";

const AssignedOPaction = ({ index, row, emp, setIsLoading, isViewOnly = false }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [selectedOption, setSelectedOption] = useState("");
  const [openMenuIdx, setOpenMenuIdx] = useState(null); // null = no menu open
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpenMenuIdx(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside); // 👈 change "click" to "mousedown"
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleActionSubmit = async (action) => {
    if (isViewOnly) return;
    const payload = {
      projectId: row._id,
      userId: emp._id,
      action: action,
    };
    setIsLoading(true);
    try {
      await dispatch(sendTrackingActionEmail(payload));

      enqueueSnackbar(
        `Task ${action === "complete"
          ? "Completed"
          : action.charAt(0).toUpperCase() + action.slice(1)
        }`,
        {
          variant: "success",
        }
      );
      dispatch(fetchAllProjects());
      setIsLoading(false);
    } catch {
      enqueueSnackbar(
        `Failed To ${action.charAt(0).toUpperCase()}${action.slice(
          1
        )} Task Details`,
        {
          variant: "error",
        }
      );
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReAssignSubmit = async (emp) => {
    if (isViewOnly) return;
    const payload = {
      projectId: row._id,
      userId: emp._id,
    };
    setIsLoading(true);
    try {
      await dispatch(reAssignProjectToOP(payload));
      enqueueSnackbar(`Project Reassigned Successfully`, {
        variant: "success",
      });
      dispatch(fetchAllProjects());
      setIsLoading(false);
    } catch {
      enqueueSnackbar(`Failed To Reassign Project`, {
        variant: "error",
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOperationReviewAction = async (row, emp) => {
    if (isViewOnly) return;
    const payload = {
      projectId: row._id,
      userId: emp._id,
    };
    setIsLoading(true);

    try {
      await dispatch(projectReviewOpAction({ payload }));
      enqueueSnackbar(`Project Sent To Review`, {
        variant: "success",
      });
      dispatch(fetchAllProjects());
      setIsLoading(false);
    } catch {
      enqueueSnackbar(`Failed To Sent Project To Review`, {
        variant: "error",
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };
  const handleManagerReviewAction = async (row, emp) => {
    if (isViewOnly) return;
    const payload = {
      projectid: row._id,
      personid: emp._id,
    };
    setIsLoading(true);

    try {
      await dispatch(projectReviewManagerAction({ payload }));
      enqueueSnackbar(`Self Review Done`, {
        variant: "success",
      });
      dispatch(fetchAllProjects());
      setIsLoading(false);
    } catch {
      enqueueSnackbar(`Failed To Sent Project To Review`, {
        variant: "error",
      });
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const [cancelPerson, setCancelPerson] = useState(null);
  const [cancelEmpBeforeAssign, setCancelEmpBeforeAssign] = useState(false);

  useEffect(() => {
    console.log("cancelPerson", cancelPerson);
  }, [cancelPerson]);

  const HandleCancelEmp = async ({ row, emp }) => {
    if (isViewOnly) return;
    const projectid = row?._id;
    const personid = emp?._id;
    setIsLoading(true);
    setCancelEmpBeforeAssign(false)
    try {
      await dispatch(cancelPersonFromProjectAssign({ projectid, personid }));
      enqueueSnackbar("Person Cancelled Successfully", {
        variant: "success",
      });
      dispatch(fetchAllProjects());
      dispatch(fetchDescriptionTasksProjectTracking());
      dispatch(fetchHardwareDescriptions());
      dispatch(fetchWorkEntriesProjectTracking());
      dispatch(fetchHardware());
      dispatch(getAllAssemblyInventory());
      dispatch(triggerEmployeesCancelAssignedRefresh());
    } catch (error) {
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        dispatch(triggerEmployeesCancelAssignedRefresh());
      }, 4000)
    }

  };

  console.log("gsdgsdgemp", emp);
  return (
    <div>
      <div className="w-full flex justify-center align-middle items-center ">
        {
          // emp?.Assignedperson?.operationaction === "complete" ||
          // emp?.customRole?.includes("project manager") &&
          emp?.Assignedperson?.manageraction === "complete" ? (
            <>
              <div className="w-full h-full flex justify-center items-center">
                <button className="cursor-default py-2 px-4 text-orange-600 border rounded-md bg-gray-100">
                  Completed
                </button>
              </div>
            </>
          ) : (
            <div className=" bg-white m-auto">
              <div
                ref={wrapperRef}
                className="relative flex p-0 rounded-xl align-middle items-center"
              >
                <button
                  disabled={
                    isViewOnly ||
                    (emp?.Assignedperson?.projecttracktaskStatus !== "submit" &&
                    emp?.customRole?.includes("project manager"))
                  }
                  type="button"
                  onClick={(e) => {
                    if (isViewOnly) return;
                    e.stopPropagation();
                    setOpenMenuIdx(openMenuIdx === index ? null : index);
                  }}
                  className={`relative w-24 border text-xs border-gray-400 rounded-md p-2 shadow-md text-start overflow-hidden outline-none
                  ${isViewOnly
                      ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed pointer-events-none"
                      : (emp?.Assignedperson?.projecttracktaskStatus !== "submit" &&
                        emp?.customRole?.includes("project manager"))
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                >
                  {emp?.Assignedperson?.manageraction === "re-assigned"
                    ? " Re-assign"
                    : selectedOption || "Select"}
                  <ExpandMoreIcon className="absolute top-1 right-0 bg-white" />
                </button>

                {openMenuIdx === index && !isViewOnly && (
                  <div
                    style={{ zIndex: 9999 }}
                    className="absolute top-full left-0 w-full p-1 bg-white text-xs border border-gray-300 shadow-lg flex flex-col gap-1"
                  >
                    {emp?.Assignedperson?.operationaction !== "reject" && (
                      <>
                        {emp?.Assignedperson?.projecttracktaskStatus ===
                          "pending" &&
                          emp?.customRole?.includes("operations") && (
                            <div
                              className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                              onClick={() => {
                                setOpenMenuIdx(null);
                                handleActionSubmit("reminder");
                                setSelectedOption("Remind");
                              }}
                            >
                              Reminder
                            </div>
                          )}
                      </>
                    )}

                    <>
                      {emp?.Assignedperson?.projecttracktaskStatus ===
                        "submit" &&
                        emp?.customRole?.includes("project manager") && (
                          <div
                            className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                            onClick={() => {
                              setOpenMenuIdx(null);
                              handleManagerReviewAction(row, emp);
                              setSelectedOption("Review");
                            }}
                          >
                            Review
                          </div>
                        )}
                    </>
                    <>
                      {emp?.Assignedperson?.projecttracktaskStatus ===
                        "submit" &&
                        emp?.customRole?.includes("operations") && (
                          <div
                            className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                            onClick={() => {
                              setOpenMenuIdx(null);
                              handleOperationReviewAction(row, emp);
                              setSelectedOption("Review");
                            }}
                          >
                            Review
                          </div>
                        )}
                    </>

                    {emp?.Assignedperson?.projecttracktaskStatus === "submit" &&
                      emp?.customRole?.includes("operations") && (
                        <div
                          className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                          onClick={() => {
                            setOpenMenuIdx(null);
                            handleActionSubmit("complete");
                            setSelectedOption("Complete");
                          }}
                        >
                          Complete
                        </div>
                      )}

                    {emp?.Assignedperson?.projecttracktaskStatus === "submit" &&
                      emp?.customRole?.includes("project manager") && (
                        <div
                          className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                          onClick={() => {
                            setOpenMenuIdx(null);
                            handleActionSubmit("complete");
                            setSelectedOption("Complete");
                          }}
                        >
                          Complete
                        </div>
                      )}

                    {emp?.Assignedperson?.operationaction === "reject" && (
                      <div
                        className="p-1 hover:bg-gray-200 text-start cursor-pointer "
                        onClick={() => {
                          handleReAssignSubmit(emp);
                          setOpenMenuIdx(null);
                          setSelectedOption("Re-assign");
                        }}
                      >
                        Re-assign
                      </div>
                    )}

                    {emp?.customRole?.includes("operations") && (
                      <div
                        className="p-1 hover:bg-gray-200 text-start cursor-pointer"
                        onClick={() => {
                          setOpenMenuIdx(null);
                          setSelectedOption("Cancel");
                          setCancelPerson({ row, emp });
                          setCancelEmpBeforeAssign(true);
                        }}
                      >
                        Cancel
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )
        }

        {cancelEmpBeforeAssign && (
          <div className="fixed inset-0 z-[1400] flex items-center justify-center bg-[rgba(0,0,0,0.4)] bg-opacity-50">
            <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
              <button
                onClick={() => {
                  setCancelEmpBeforeAssign(false);
                  setCancelPerson(null);
                  setSelectedOption("")
                }}
                className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
              >
                Close
              </button>

              <p className="mt-6 text-lg font-medium text-start">
                Are you sure you want to cancel all responses of{" "}
                <span className="text-blue-600">
                  {cancelPerson?.emp?.fullName}{" "}
                </span>{" "}
              </p>

              <div className="flex justify-start gap-4 mt-6">
                <button
                  onClick={() => {
                    HandleCancelEmp(cancelPerson);
                  }}
                  className="py-2 px-7 bg-[#e32278] text-white rounded-lg"
                >
                  Yes
                </button>
                <button
                  onClick={() => {
                    setCancelPerson(null);
                    setCancelEmpBeforeAssign(false);
                    setSelectedOption("")
                  }}
                  className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black text-white rounded-lg"
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssignedOPaction;
